import React from 'react';
import styles from './SpendingIndicator.module.css';

interface SpendingIndicatorProps {
  spendingAmount: number;
  monthlyIncome: number;
}

const SpendingIndicator: React.FC<SpendingIndicatorProps> = ({ spendingAmount, monthlyIncome }) => {
  const getIndicatorStatus = () => {
    if (spendingAmount > monthlyIncome) {
      return {
        color: 'red',
        message: 'Your estimated spending exceeds your monthly income',
        icon: '🔴'
      };
    }

    const percentageDifference = ((monthlyIncome - spendingAmount) / monthlyIncome) * 100;

    if (percentageDifference < 20) {
      return {
        color: 'orange',
        message: 'Your spending is close to your income',
        icon: '🟡'
      };
    }

    return {
      color: 'green',
      message: 'Great! You have good room in your budget',
      icon: '🟢'
    };
  };

  const status = getIndicatorStatus();

  return (
    <div className={`${styles.spendingIndicator} ${styles[status.color]}`}>
      <div className={styles.header}>
        <span className={styles.icon}>{status.icon}</span>
        <span className={styles.title}>Spending vs Income</span>
      </div>
      <div className={styles.details}>
        <div className={styles.amounts}>
          <span>Monthly Income: ${monthlyIncome.toLocaleString()}</span>
          <span>Estimated Spending: ${spendingAmount.toLocaleString()}</span>
        </div>
        <div className={styles.message}>{status.message}</div>
      </div>
    </div>
  );
};

export default SpendingIndicator;